import Button from "./Button";
import Link, { PlainLink } from "./navigation/NavLink";

export const RouterLinkButton = Button.withComponent(Link);
export const LinkButton = Button.withComponent(PlainLink);
